import { FC } from 'react';
import { useSelector } from 'react-redux';

import { getIsDesktop, getIsTouchscreen } from 'src/store/agent/selectors';

import { DesktopPageActions } from './DesktopPageActions/DesktopPageActions';
import { MobilePageActions } from './MobilePageActions/MobilePageActions';

export const ParkingBookingPageActions: FC = () => {
  const isDesktop = useSelector(getIsDesktop);
  const isTouchScreen = useSelector(getIsTouchscreen);

  return isDesktop ? (
    <DesktopPageActions />
  ) : isTouchScreen ? null : (
    <MobilePageActions />
  );
};
